// import {store1} from '../store/index'

var DataStore = require('../store');
var store = DataStore.default

// const fetchPOST =  () =>{
//     return 'store.state.url.URL_APP'
// }

const fetchPOST = () => {
  return store.state.kamio
}

const getKab = (wilayah) => {
  fetch(store.state.url.URL_DATAMASTER_KAB_KOTA + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      wilayah: wilayah
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.listKabKota = res_data
    });
}


const getTPS = (des_kel) => {
  fetch(store.state.url.URL_DATAMASTER_TPS + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      des_kel: des_kel
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.listTps = res_data
    });
}


const getVisi = () => {
  fetch(store.state.url.URL_ADM_VISI + "list", {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: "kikensbatara " + localStorage.token
    },
    body: JSON.stringify({
      des_kel: ''
    })
  })
    .then(res => res.json())
    .then(res_data => {
      console.log(res_data)
      store.state.listVisi = res_data
    });
}



const getEditMenuListLevelAkses = async (menu_levelUsers_id) => {
  return new Promise(resolve =>{
      fetch(store.state.url.URL_LEVEL_USERS + "getOne", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            menu_levelUsers_id: menu_levelUsers_id,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              resolve(res_data)
      });
  })
}



const getEditMenuListLevelAkses_Login = async (menu_levelUsers_id) => {
 
  return new Promise(resolve =>{
      fetch(store.state.url.URL_LEVEL_USERS + "getOneLogin", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            menu_levelUsers_id: menu_levelUsers_id,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              resolve(res_data)
      });
  })
}


const fetch_postx = async (url, bodyx) => {
  return new Promise((resolve) => {
    fetch(url, {
      method: "POST",
      headers: {
        "content-type": "application/json",
        authorization: "kikensbatara " + localStorage.token
      },
      body: bodyx
    })
    .then(res => res.json())
    .then(res_data => {
      // console.log(res_data)
      // store.state.listKabKota = res_data
      resolve(res_data)
    });

  })
}



module.exports = {
  fetchPOST: fetchPOST,
  getKab : getKab,
  getTPS : getTPS,
  getVisi : getVisi,
  getEditMenuListLevelAkses : getEditMenuListLevelAkses,
  getEditMenuListLevelAkses_Login : getEditMenuListLevelAkses_Login,
  fetch_postx : fetch_postx

}